/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * external is an organization-level remote session issuer that exchanges the user's identity for an ID-JAG, such as an Okta authorization server; speakeasy is the organization's internal session issuer.
 */
export const EMAProviderInputKind = {
  External: "external",
  Speakeasy: "speakeasy",
} as const;
/**
 * external is an organization-level remote session issuer that exchanges the user's identity for an ID-JAG, such as an Okta authorization server; speakeasy is the organization's internal session issuer.
 */
export type EMAProviderInputKind = ClosedEnum<typeof EMAProviderInputKind>;

/**
 * One EMA provider allowed to issue ID-JAGs for a vendor.
 */
export type EMAProviderInput = {
  /**
   * external is an organization-level remote session issuer that exchanges the user's identity for an ID-JAG, such as an Okta authorization server; speakeasy is the organization's internal session issuer.
   */
  kind: EMAProviderInputKind;
  /**
   * Required for external, omitted for speakeasy: an organization-level issuer that an organization user session issuer trusts.
   */
  remoteSessionIssuerId?: string | undefined;
};

/** @internal */
export const EMAProviderInputKind$outboundSchema: z.ZodMiniEnum<
  typeof EMAProviderInputKind
> = z.enum(EMAProviderInputKind);

/** @internal */
export type EMAProviderInput$Outbound = {
  kind: string;
  remote_session_issuer_id?: string | undefined;
};

/** @internal */
export const EMAProviderInput$outboundSchema: z.ZodMiniType<
  EMAProviderInput$Outbound,
  EMAProviderInput
> = z.pipe(
  z.object({
    kind: EMAProviderInputKind$outboundSchema,
    remoteSessionIssuerId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      remoteSessionIssuerId: "remote_session_issuer_id",
    });
  }),
);

export function emaProviderInputToJSON(
  emaProviderInput: EMAProviderInput,
): string {
  return JSON.stringify(
    EMAProviderInput$outboundSchema.parse(emaProviderInput),
  );
}
